import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { THRESHOLD } from '../../../../../config/constants';
import { ThresholdSelectorPropsType } from '../types';

const ThresholdSelector = ({newData, setNewData}: ThresholdSelectorPropsType ) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <label>Select Threshold</label>
      <Dropdown className="a-select" show={show} onToggle={show ? () => setShow(false) : () => setShow(true)}>
        <Dropdown.Toggle
          id="dropdown-threshold"
          className={`btn-gray-l label-year-selector${newData.threshold !== 'Select' ? '-selected' : ''}`}
        >
          <label className={'label-label'} style={{lineHeight: '21px'}}>{newData.threshold !== 'Select' && newData.threshold !== 800000 ? newData.threshold  + ' %' : 'Select'}</label>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <ul>
            {THRESHOLD.map((thresh, index) => (
              <li key={index}>
                <div
                  onClick={() => {
                    setNewData({
                        ...newData,
                        threshold: thresh.value
                      });
                    setShow(false);
                  }} className={'label-select-year'}
                >{thresh.label}</div>
              </li>
            ))}
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default ThresholdSelector;